<template>
  <q-card
    id="_tlqn_admin_group_user_list_manage"
    class="q-px-lg q-pt-xl q-pb-md column justify-between"
    style="width: 80vw;max-width: 1200px;height: 80vh;max-height: 800px"
  >
    <header class="row items-center justify-center">
      <q-input
        dense
        filled
        label="搜索 用户名/手机号/昵称"
        style="width: 50%"
        v-model="searchInput"
      />
      <q-icon
        name="fas fa-times-circle"
        class="absolute text-grey cursor-pointer"
        style="right: 50px"
        size="20px"
        @click="cancel()"
      />
    </header>

    <q-table
      style="max-height: calc(100% - 150px);height: calc(100% - 150px)"
      class="rounded-borders sticky-header-table q-my-md"
      :data="filteredUserList"
      :columns="columnDef"
      :loading="loading"
      row-key="index"
      virtual-scroll
      :pagination.sync="pagination"
      :rows-per-page-options="[0]"
      separator="horizontal"
      hide-bottom
    >
      <template v-slot:top>
        <div class="full-width row justify-between">
          <div style="font-size: 1.2rem; font-weight: bold">
            <span> 共有{{ filteredUserList.length }}个可分配的访员 </span>
            <span class="text-grey" style="font-size: 0.8rem">
              （ 其中，<span class="text-primary">{{ inGroupCount }}</span>
              名访员已分配到当前分组，
              <span class="text-primary">{{ inOtherGroupCount }}</span>
              名访员已分配到其他分组，
              <span class="text-primary">{{ noGroupCount }}</span>
              名访员尚未分配 ）
            </span>
          </div>

          <div></div>
        </div>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="add" :props="props">
            <q-checkbox v-model="checkModel[props.row.id]" />
          </q-td>
          <q-td key="group" :props="props">
            <q-badge
              dense
              v-if="!props.row.group"
              color="grey"
              text-color="white"
            >
              未分配
            </q-badge>
            <q-badge
              v-else-if="props.row.group === groupId"
              color="green"
              text-color="white"
            >
              已分配到当前组
            </q-badge>
            <q-badge
              v-else-if="props.row.group !== groupId"
              color="red"
              text-color="white"
            >
              已分配到其他组
            </q-badge>
          </q-td>
          <q-td key="nickname" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchInput"
              :text="props.row.nickname"
            />
          </q-td>
          <q-td key="username" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchInput"
              :text="props.row.username"
            />
          </q-td>
          <q-td key="phone_number" :props="props">
            <MatchHighlight
              v-if="props.row.phone_number"
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchInput"
              :text="props.row.phone_number"
            />
            <span v-else class="text-grey">
              未绑定手机号
            </span>
          </q-td>
        </q-tr>
      </template>
    </q-table>

    <footer style="height: 60px" class="row justify-end items-center">
      <q-btn outline color="grey-8" class="q-px-md" @click="cancel">
        取消
      </q-btn>
      <q-btn
        flat
        class="text-white bg-primary q-ml-sm q-px-md"
        :disable="!checkChanged"
        @click="updateGroupMember"
        :loading="loading"
      >
        确认
      </q-btn>
    </footer>
  </q-card>
</template>

<script>
import { fetchUserList } from "@/api/endpoints/user/fetchUserList";
import { updateGroupMember } from "@/api/endpoints/group/updateGroupMember";
import { roughlyToPlain } from "@/utils/roughly-to-plain";
const columnDef = [
  {
    name: "add",
    label: "加入分组",
    align: "center",
    style: "width: 80px",
  },
  {
    name: "group",
    label: "用户状态",
    field: "group",
    align: "center",
    sortable: true,
    style: "width: 100px",
  },
  {
    name: "nickname",
    label: "昵称",
    field: "nickname",
    align: "center",
    sortable: true,
  },
  {
    name: "username",
    label: "账号",
    field: "username",
    align: "center",
  },
  {
    name: "phone_number",
    label: "手机号",
    field: "phone_number",
    align: "center",
    sortable: true,
  },
];
export default {
  components: {
    MatchHighlight: () => import("@/components/MatchHighlight"),
  },
  props: {
    groupId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      searchInput: "",
      loading: true,
      userList: [],
      columnDef,
      pagination: {
        rowsPerPage: 0,
      },

      checkModel: {},
      orginCheck: {},
      checkInited: false,
    };
  },

  mounted() {
    this.getUserList();
    this.initUserStateSort();
  },

  computed: {
    inGroupCount() {
      return this.filteredUserList.filter((u) => u.group === this.groupId)
        .length;
    },

    inOtherGroupCount() {
      return this.filteredUserList.filter(
        (u) => u.group && u.group !== this.groupId
      ).length;
    },

    noGroupCount() {
      return this.filteredUserList.filter((u) => !u.group).length;
    },

    /**
     * 计算是否已选择过
     */
    checkChanged() {
      return (
        this.checkInited &&
        JSON.stringify(this.checkModel) !== JSON.stringify(this.orginCheck)
      );
    },

    filteredUserList() {
      const { userList, searchInput } = this;
      return userList.filter((u) => {
        return (
          (u.nickname && u.nickname.match(new RegExp(searchInput, "i"))) ||
          (u.username && u.username.match(new RegExp(searchInput, "i"))) ||
          (u.phone_number && u.phone_number.match(new RegExp(searchInput, "i")))
        );
      });
    },
  },

  methods: {
    initUserStateSort() {
      const t = this.columnDef.find((def) => def.name === "group");
      const sort = (a, b, rowA, rowB) => {
        const getV = (id) => {
          if (!id) return 2;
          if (id === this.groupId) return 0;
          return 1;
        };
        return getV(a) - getV(b);
      };
      this.$set(t, "sort", sort);
    },

    /**
     * 获取用户列表
     */
    async getUserList() {
      try {
        const response = await fetchUserList({
          role: "member",
          cascadeId: true,
          cascade: {
            group: true,
          },
        });
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.userList = response.filter((u) => !u.group);
          this.initCheck();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "获取用户列表时出现错误",
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * 初始化选择状态
     */
    initCheck() {
      const { userList } = this;
      this.checkModel = userList.reduce((res, user) => {
        res[user.id] = user.group === this.groupId;
        return res;
      }, {});
      this.orginCheck = roughlyToPlain(this.checkModel);
      this.checkInited = true;
    },

    cancel() {
      this.$emit("cancel");
    },

    async updateGroupMember() {
      this.loading = true;
      const { checkModel, orginCheck } = this;
      const append = [];
      const remove = [];
      const userIds = Object.keys(checkModel);
      for (let i = 0; i < userIds.length; i++) {
        const userId = userIds[i];
        if (checkModel[userId] === orginCheck[userId]) continue;
        (checkModel[userId] ? append : remove).push(userId);
      }
      try {
        const response = await updateGroupMember(this.groupId, {
          append,
          remove,
        });
        if (response.status && response.status !== 1) {
          this.$q.notify({
            type: "danger",
            message: "更新时发生未知错误",
          });
        } else {
          this.$q.notify({
            type: response.status ? "warning" : "success",
            message: `共添加${append.length}到分组，成功${response.append_count}人，从分组内移除${remove.length}人，成功${response.remove_count}人`,
          });
          this.$emit("updated");
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "更新时发生未知错误",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.tlqn-ad-gmls-search-match {
  background-color: $primary;
  font-weight: bold;
  color: #fff;
  box-shadow: $shadow-1;
}

#_tlqn_admin_group_user_list_manage {
  .q-table__container {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
}

.sticky-header-table {
  /* height: 310px; */
  border-radius: $generic-border-radius !important;

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: $grey-2;
  }

  .q-table__middle.q-virtual-scroll.scroll {
    overflow: hidden;
    transition: all 0.1s ease;
    &:hover {
      overflow: auto;
    }
  }

  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
  }
}
</style>
